<template>
  <div class="login-container">
    <nav-bar :showBack="false" :isRoot="true"/>

    <div v-if="clientName" class="page-title">
      {{ $t('登录授权标题前缀') }}<span class="client-name">{{ ' ' + clientName + ' '}}</span>{{ $t('登录授权标题后缀') }}
    </div>

    <img class="viomi-logo" src="@/icons/viomi_logo.png">
    <van-form @submit="onSubmit">
      <common-drop-down-view v-if="canSwitchRegion" :show-text="showRegion" @onDropDownClick="onRegionClick"/>

      <van-field class="custom-field" v-model="user.mobile" :placeholder="$t('请输入邮箱/手机号/云米账号')" type="text" clearable>
      </van-field>

      <pwd-input-view v-model="user.password" :placeholder="$t('请输入密码')"/>

      <!-- <div class="forget-pwd" @click="forgetPwd"> {{$t('忘记密码')}} </div> -->
      <van-button class="login-btn" :disabled="!user.mobile||!user.password|| protocolFlag==false" block type="info" native-type="submit" @touchstart="onFailed()">
        {{ $t('授权登录') }}
      </van-button>
      <entrance-view :data="entranceList" @clickEntrance="clickEntrance"/>
      <protocol-view v-model="protocolFlag" :platform="clientName" @clickProtocol="goLink"/>
    </van-form>

    <check-list-popup-view v-model="regionPopupShow" :title="$t('选择地区')" :select-index="regionSelectIndex" :option-list="regionOptionList" @onClickItem="onClickRegionItem"/>

    <tip-popup-view v-model="tipShow" :tip-content="tipContent" :button-content="tipButton"/>

    <van-popup v-model="show" round position="bottom" :style="{ height: '70%' }"><iframe class="iframeBody" :src="iframeLink"></iframe></van-popup>
  </div>
</template>
<script>
import { Icon, Form, Field, Button, CheckboxGroup, Checkbox, CountDown, Toast, Popup, Dialog } from 'vant'
import { Encrypt } from '@/utils/crypto.js'
import md5 from 'js-md5'
import ProtocolView from '@/components/ProtocolView'
import EntranceView from '@/components/EntranceView'
import NavBar from '@/components/NavBar'
import { EntranceType, VerifyType } from '@/config/entrance.js'
import TipPopupView from '@/components/TipPopupView'
import PageBase from '@/mixin/page-base'
import SwitchRegion from '@/mixin/switch-region'
import PwdInputView from '@/components/PwdInputView'
import CheckListPopupView from '@/components/CheckListPopupView'
import CommonDropDownView from '@/components/CommonDropDownView'

export default {
  mixins: [PageBase, SwitchRegion],
  components: {
    CommonDropDownView,
    CheckListPopupView,
    PwdInputView,
    ProtocolView,
    EntranceView,
    NavBar,
    TipPopupView,
    [Icon.name]: Icon,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [CountDown.name]: CountDown,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog
  },
  props: {},
  data () {
    return {
      verifyType: VerifyType.SMS,
      entranceList: [EntranceType.SMSLOGIN, EntranceType.REGISTER, EntranceType.FORGETPWD],
      user: {
        mobile: '',
        password: ''
      },
      show: false,
      iframeLink: '',
      openEye: false,
      protocolFlag: false,
      regionPopupShow: false
    }
  },
  computed: {
  },
  watch: {},
  created () {
  },
  mounted () {
    document.title = this.$t('云米授权')
    this.initParamter()
  },
  methods: {
    clickEntrance(type){
      const query = { ...this.$route.query }
      if (this.clientName) {
        query.clientName = this.clientName
      }

      switch (type) {
        case EntranceType.REGISTER:
          this.$router.push({ path: '/register', query })
          break
        case EntranceType.SMSLOGIN:
          this.$router.push({ path: '/sms-login', query })
          break
        case EntranceType.FORGETPWD:
          this.$router.push({ path: '/forget-pwd', query })
          break
        default:
          break
      }
    },

    onFailed () {
      if (this.user.mobile && this.user.password && !this.protocolFlag) {
        Toast(this.$t('请先同意服务条款'))
      }
    },
    onSubmit () {
      const user = this.user

      if (!this.isValidPassword(user.password)) {
        Toast(this.$t('密码格式错误'))
        return
      }

      let data = {
        authorization: this.authorization()
      }

      data.pwdAuthentication = {
        account: Encrypt(user.mobile),
        password: md5(user.password)
      }
      data.authentication = {
        loginType: 'pwd',
        userType: '2'
      }

      this.commonAuth(data)
    },

    goLink (link) {
      this.iframeLink = link
      this.show = true
    }

  }
}
</script>
<style scoped lang="less">
.login-container {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  padding: 0px 24px;
  .viomi-logo {
    width: 59px;
    height: 52px;
    margin-top: 28px;
    margin-bottom: 24px;
    align-self: center;
  }
  .page-title {
    margin-bottom: 8px;
    font-size: 17px;
    font-weight: 500;
    color: #2C2C2C;
    align-self: center;
    text-align: center;

    .client-name {
      color: #00AAAE;
    }
  }
  .custom-field {
    background-color: #F5F7FA;
    margin-top: 8px;
    border-radius: 8px;
    font-size: 14px;
  }
  .custom-field /deep/ .van-field__control {
    border-bottom: none;
    height: 40px;
  }
  .custom-field /deep/ .van-field__button {
      display: flex;
      align-items: center;
    }
  .forget-pwd {
    font-size: 12px;
    font-weight: 400;
    color: gray;
    align-self: flex-end;
    text-align: right;
    margin-top: 16px;
  }

  .input-desc {
    font-size: 10px;
    color: #999999;
    line-height: 20px;
    position: relative;
    opacity: 0;
  }
  .inputDescAct {
    opacity: 1;
    animation: myfirst 0.05s;
    -webkit-animation: myfirst 1s; /* Safari and Chrome */
  }
  @keyframes myfirst {
    0% {
      opacity: 0;
      left: 0px;
      top: 5px;
    }
    100% {
      opacity: 1;
      left: 0px;
      top: 0px;
    }
  }

  @-webkit-keyframes myfirst /* Safari and Chrome */ {
    0% {
      opacity: 0;
      left: 0px;
      top: 5px;
    }
    100% {
      opacity: 1;
      left: 0px;
      top: 0px;
    }
  }
  .send-sms-btn {
    height: 16px;
    line-height: 16px;
    font-size: 13px;
    color: #28beca;
  }
  .login-btn {
    margin-top: 16px;
    background: linear-gradient(90deg, #5fd1db 0%, #28beca 100%);
    border: none;
    border-radius: 8px;
    height: 48px;
    font-size: 14px;
    width:327px;
  }
  .countDownBlock {
    color: #ace6ebff;
    font-size: 13px;
  }
  .captchaImg {
    width: 80px;
  }
  .iframeBody {
    width: 100%;
    height: 100%;
  }
}
</style>
